var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-12" }, [
    _c("label", { attrs: { for: "timezone" } }, [
      _vm._v("\n        " + _vm._s(_vm.label) + " "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ]),
    _vm._v(" "),
    _c(
      "select",
      { attrs: { name: "timezone" }, on: { change: _vm.selectTimeZone } },
      _vm._l(_vm.zones, function (timezone) {
        return _c(
          "option",
          { domProps: { selected: timezone === _vm.value } },
          [_vm._v(_vm._s(timezone))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("timezone"),
            expression: "errors.has('timezone')",
          },
        ],
        staticClass: "error text-error-red text-lg",
      },
      [_vm._v(_vm._s(_vm.errors.first("timezone")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }